import { useEffect, useState } from 'react'
import style from './Clock.module.css'

function Clock(props) {
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [seconds, setSeconds] = useState(0)

  const getTimeUntil = (deadline) => {
    const time = Date.parse(deadline) - Date.parse(new Date());
    setSeconds(Math.floor((time/1000) % 60));
    setMinutes(Math.floor((time/1000/60) % 60));
    setHours(Math.floor((time/(1000*60*60)% 24)));
    setDays(Math.floor((time/(1000*60*60*24))));
  }

  useEffect(() => {
    // console.log(props.deadline);
    getTimeUntil(props.deadline);
  })

  useEffect(() => {
    setInterval(() => getTimeUntil(props.deadline), 1000)
  }, [props.deadline])

  const leading0 = (num) => {
    return num < 10 ? '0' + num : num
  }

return (
        <div className="row justify-content-center countDown">
            <div className="card col"><div class="card-body"><h5 class="card-title">{leading0(days)}</h5><p class="card-text">days</p></div></div>
            <div className="card col"><div class="card-body"><h5 class="card-title">{leading0(hours)}</h5><p class="card-text">hours</p></div></div>
            <div className="card col"><div class="card-body"><h5 class="card-title">{leading0(minutes)}</h5><p class="card-text">min</p></div></div>
            <div className="card col"><div class="card-body"><h5 class="card-title">{leading0(seconds)}</h5><p class="card-text">sec</p></div></div>
        </div>
  )
}

export default Clock